module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }